import { Container, Row } from 'react-bootstrap'
import styled from 'styled-components'

export const HomePageHeader = styled(Container)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    gap: 2rem;
    margin-top: 0.5rem;
    @media only screen and (max-width: 810px) {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
`

export const HomePageMain = styled(Row)`
    width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    @media only screen and (min-width: 810px) {
        gap: 2rem;
        flex-direction: row;
    }
`
